module.exports = __webpack_public_path__ + "cae6402ffbee113537d8cf342c369b94.svg";